export default "__VITE_ASSET__CqTR27F$__"